import React, { FC } from 'react';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';

interface TopBlockProps {
    newItem: boolean;
    disableEdit: boolean;
    permissionDelete: boolean;
    handleSave: () => void;
    handleDelete: () => void;
}

const TopBlock: FC<TopBlockProps> = (props) => {
    return (
        <BodyTopBlock
            actions={[
                {
                    label: translate('transportPackageTypeDetail.action.save'),
                    onClick: props.handleSave,
                    hidden: props.disableEdit,
                    'data-testid': 'package-type-save',
                },
                {
                    label: translate('transportPackageTypeDetail.action.deactivate'),
                    onClick: props.handleDelete,
                    hidden: props.newItem || !props.permissionDelete,
                    variant: 'outlined',
                    'data-testid': 'package-type-deactivate',
                },
            ]}
        />
    );
};

export default TopBlock;
